import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["index", "innerRef"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PropTypes from 'prop-types';
import { Link, IndexLink } from 'react-router';

/**
 * A link that is either a <Link> or an <IndexLink> based on the `index` property.
 */
export default function AgnosticLink(_ref) {
  var index = _ref.index,
    innerRef = _ref.innerRef,
    props = _objectWithoutProperties(_ref, _excluded);
  var LinkComponent = props.to ? index ? IndexLink : Link : 'a';
  return /*#__PURE__*/React.createElement(LinkComponent, _objectSpread(_objectSpread({}, props), !innerRef || (LinkComponent === 'a' ? {
    ref: innerRef
  } : {
    innerRef: innerRef
  })));
}
AgnosticLink.propTypes = {
  index: PropTypes.bool,
  to: PropTypes.string
};
//# sourceMappingURL=index.js.map
